exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".linkText {\n  color: var(--link-primary-color);\n  cursor: pointer;\n  font-weight: bold;\n  text-decoration: underline;\n  margin: 0 8px;\n  font-size: 0.75rem;\n  font-family: 'Lato-Bold', sans-serif; }\n", ""]);

// exports
